export const MARKER = Symbol('dom-event-marker')

export class EventMarkerStackingIdCreator {
  static instance: EventMarkerStackingIdCreator | null = null

  private nextId: number = 0

  constructor() {
    if (!EventMarkerStackingIdCreator.instance) {
      EventMarkerStackingIdCreator.instance = this
    }
  }

  static destroy() {
    EventMarkerStackingIdCreator.instance = null
  }

  static create() {
    let instance = EventMarkerStackingIdCreator.instance
    if (!instance) {
      instance = new EventMarkerStackingIdCreator()
    }

    const id = instance.nextId

    instance.nextId += 1

    return id
  }
}

export const markEvent = (event: Event, stackingId: number) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(event as any)[MARKER] = stackingId
}

export const isContainedEvent = (event: Event, stackingId: number) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const id = (event as any)[MARKER] as number | undefined
  return id !== undefined && id >= stackingId
}
